import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { AuthService, User } from '../../services/auth.service';
import { LayoutService } from '../../services/layout.service';
import { HugeiconsIconComponent } from '@hugeicons/angular';
import {
    DashboardSquare01Icon,
    FileSearchIcon,
    UserIcon,
    Folder01Icon,
    Logout01Icon,
    SidebarLeft01Icon,
    Menu01Icon
} from '@hugeicons/core-free-icons';

interface NavItem {
    label: string;
    route: string;
    icon: any;
    roles?: string[];
}

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, HugeiconsIconComponent],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
    isCollapsed = false;
    isMobileOpen = false;
    currentUser: User | null = null;

    // Icons
    logoutIcon = Logout01Icon;
    collapseIcon = SidebarLeft01Icon;
    menuIcon = Menu01Icon;

    navItems: NavItem[] = [
        { label: 'Dashboard', route: '/dashboard', icon: DashboardSquare01Icon, roles: ['ADMIN', 'ATTORNEY'] },
        { label: 'Case Inquiry', route: '/case-enquiry', icon: FileSearchIcon, roles: ['ADMIN', 'ATTORNEY'] },
        { label: 'Cases', route: '/cases', icon: Folder01Icon, roles: ['ADMIN', 'ATTORNEY'] },
        { label: 'Attorney', route: '/attorney', icon: UserIcon, roles: ['ADMIN'] },
        { label: 'Cases', route: '/assistant-cases', icon: Folder01Icon, roles: ['ASSISTANT'] },
    ];

    constructor(
    private authService: AuthService,
    private layoutService: LayoutService
  ) { }

  ngOnInit(): void {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });

    this.layoutService.sidebarCollapsed$.subscribe(collapsed => {
      this.isCollapsed = collapsed;
    });

    this.layoutService.mobileSidebarOpen$.subscribe(open => {
      this.isMobileOpen = open;
    });
  }

  toggleSidebar() {
    this.layoutService.toggleSidebar();
  }

  closeMobileSidebar() {
    this.layoutService.closeMobileSidebar();
  }

  onNavClick() {
    // Close mobile sidebar when navigating
    if (window.innerWidth <= 1024) {
      this.layoutService.closeMobileSidebar();
    }
  }

  logout() {
    this.authService.logout();
  }

  hasAccess(item: NavItem): boolean {
    if (!item.roles || item.roles.length === 0) {
      return true;
    }
    return this.currentUser?.role ? item.roles.includes(this.currentUser.role) : false;
  }
}
